import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'char2br',
  // pure: true,
})
export class Char2brPipe implements PipeTransform {
  constructor() { }

  transform(content: string | null | undefined, char: string): string | null {
    return content ? content.replaceAll(char, '<br />') : null;
  }

}
